<template>
  <div v-clickOutside="handleClose" class="ioc-picker-contain">
    <div
      :class="['ioc-picker', isVisible ? 'focus' : '']"
      @click="handleVisible($event)"
    >
      <div class="picker-info"></div>
      <i class="el-icon-date"></i>
    </div>
    <div :class="['picker-prop']" v-if="isVisible">
      <div
        v-for="(row, index) in dataType == 0 ? dateListData : dateListTime"
        :key="index"
        class="row"
      >
        <div
          v-for="(col, key) in row"
          :key="key"
          :class="['col', hasActive(col)]"
          @click="handleClick(col)"
        >
          <span>
            {{ col }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clickOutside from "../utils/clickoutside";
export default {
  directives: { clickOutside },
  name: "picker",
  props: {
    dataType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dateList: [],
      dateListData: [
        [1, 2, 3, 4, 5, 6, 7],
        [8, 9, 10, 11, 12, 13, 14],
        [15, 16, 17, 18, 19, 20, 21],
        [22, 23, 24, 25, 26, 27, 28],
        [29, 30, 31],
      ],
      dateListTime: [
        [0, 1, 2, 3, 4, 5, 6],
        [7, 8, 9, 10, 11, 12],
        [13, 14, 15, 16, 17, 18],
        [19, 20, 21, 22, 23, 24],
      ],
      activeList: [],
      minDate: 0,
      maxDate: 0,
      startDate: null,
      endDate: null,
      isVisible: false,
    };
  },
  watch: {
    activeList: function (newVal) {
      if (newVal.length === 2) {
        let arr = [];
        if (newVal[0] > newVal[1]) {
          arr = [newVal[1], newVal[0]];
        } else {
          arr = newVal;
        }
        setTimeout(() => {
          this.$emit("change", arr);
          this.handleClose();
        }, 500);
      }
    },
  },
  mounted() {
    // this.dateList = this.dateListData;
  },
  methods: {
    hasActive(col) {
      if (this.activeList.some((item) => item === col)) {
        return "active";
      } else {
        return "";
      }
    },
    handleClick(val) {
      this.activeList.push(val);
    },
    // 是否展示下拉选项卡
    handleVisible(e) {
      this.isVisible = !this.isVisible;
      this.$emit("handleVisible", this.isVisible);
    },
    handleClose() {
      this.isVisible = false;
      this.activeList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.ioc-picker-contain {
  width: 100%;
  height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 1px;
  padding: 0 10px;
  position: relative;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .ioc-picker {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    width: 100%;

    .picker-info {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-icon-date {
      font-size: 14px;
      color: #c0c4cc;
      float: left;
    }
  }

  .picker-prop {
    width: 100%;
    position: absolute;
    z-index: 999;
    left: 0;
    display: flex;
    border: 1px solid #1486f8;
    background-color: #fff;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s;
    .row {
      display: flex;
      flex-direction: row;
      .col {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 28px;
        height: 28px;
        flex: 1;
        padding: 4px 0;
        box-sizing: border-box;
        text-align: center;
        cursor: pointer;
        position: relative;
      }
      .active {
        span {
          background-color: #409eff;
          border-radius: 50%;
          width: 25px;
          height: 25px;
          line-height: 25px;
        }
      }
    }
  }
}
</style>
